export default __webpack_public_path__ + "static/media/Periyar (1) 1.c2e7850c.png";